Eshop.alert = function(msg, options) {
    let settings = $.extend({
        allow_dismiss: true,
        type: 'success',
        animate: {
            enter: 'fadeInRight',
            exit: 'fadeOutRight'
        },
        placement: {
            from: 'bottom'
        },
        gap: 2,
        delay: 6500,
        mouse_over: 'pause',
        offset: {
            y: checkMedia('cxs,xs') ? 15 : 50,
            x: 0
        },
        z_index: 3003,
        template:
            '<div data-notify="container" class="notify custom {0}" role="alert">' +
                '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">' +
                    '<i class="ico ico-close" aria-hidden="true"></i>' +
                '</button>' +
                '<span class="message" data-notify="message">{2}</span>' +
            '</div>'
    }, options);

    $.notify(msg, settings);
}

Cart.addItem = function (form) {
    var $quantityInput = $(form).find('input[name="quantity"]'),
        $submitButton = $(form).find('[type="submit"]');

    if ($submitButton.hasClass('is-loading')) {
        return false;
    }

    $submitButton.addClass('is-loading');

    if ($quantityInput.size() == 1 && $quantityInput.val() && parseInt($quantityInput.val()) < 1) {
        $quantityInput.val(Math.abs($quantityInput.val()));
    }

    Event.dispatch('Cart.product.before_add');

    Form.ajaxPost(form, function (response) {
        var $form = $(form),
            $customForceInput = $form.find('input[name="custom_force"]');

        if (!response.status && response.custom_already_in_cart) {
            Eshop.confirm(response.message, {
                type: 'info',
                cancelButtonText: $form.find('[type="submit"]').data('cancel-text') || 'Zrušiť',
                confirmButtonText: $form.find('[type="submit"]').data('confirm-text') || 'Vložiť do košíka',
                confirmButtonColor: '#FF7606'
            }, function() {
                $customForceInput.val(1);
                Cart.addItem(form);
            });
        } else {
            Cart.callbacks.addedItem(form, response);
            Event.dispatch('Cart.product.after_add', response);
        }

        $customForceInput.val(0);
        $submitButton.removeClass('is-loading');
    }, 'json');

    return false;
};

Cart.customCallbacks.addedItem = function(form, response) {
    if (response.status) {
        setTimeout(function() {
            Eshop.alert(getShippingMessage(response), {type: 'warning'});
        }, 100);
    }
};

Spinner.template = "{{value}} {{append}}";

Form.buildSpinners = function() {
    Form.buildSpinnersInside('body');
}

Form.buildSpinnersInside = function(selector) {
    $.widget( "ui.spinner", $.ui.spinner, {
        _format: function(value) {
            let $elem = $(this.element),
                append = '';

            if ($elem.data('spinner-append')) {
                append = $elem.data('spinner-append');
            }

            return _.template(Spinner.template)({
                value: value,
                append: append
            });
        },
        _parse: function(value) {
            return parseInt(value);
        }
    });

    $(selector).find('input.ui-spinner').each(function() {
        const $spinner = $(this);

        if (!$spinner.data('uiSpinner')) {
            $(this).spinner(Spinner.options);
        }
    });
}

Form.rebuildSpinnersInside = function(selector) {
    $(selector).find(".ui-spinner").spinner().spinner("destroy");
    Form.buildSpinnersInside(selector);
}

function rebuildTopPaginator() {
    const $paginator = $('.listing.products').find('.pager');

    if ($('.js-top-paginator').length && $paginator.length) {
        $paginator.clone().appendTo('.js-top-paginator');
    }
}

Event.on('Listing.fetchedData', function(data) {
    bLazy.revalidate();

    setTimeout(function() {
        bLazy.revalidate();

        tippy('.js-tippy:not([data-tippy])', {
            arrow: true
        });
    }, 250);

    rebuildTopPaginator();
});

function toggleFullscreenOverlay(show) {
    const $overlay = $('.c-overlay--fullscreen');

    if (show === 'undefined') {
        show = !$overlay.is(':visible');
    }

    $overlay.toggleClass('is-active', show);
}

function showFullscreenOverlay() {
    toggleFullscreenOverlay(true);
}

function hideFullscreenOverlay() {
    toggleFullscreenOverlay(false);
}

$(function() {
    $('.js-custom-form-modal-login').validate({
        submitHandler: function(form) {
            Form.ajaxPost(form, function(data) {
                $('.js-login-error').hide();

                if (!data.status) {
                    $('.js-login-error')
                        .text(data.message)
                        .slideDown();
                } else {
                    $('.js-login-hide').slideUp(250);
                    $('.js-login-success').slideDown(250, function() {
                        location.reload();
                    });
                }
            }, 'json');
        }
    });
});
